import { TFunction, i18n as I18n } from 'i18next';
import { BaseSchema } from 'yup';
import * as Yup from 'yup';
import { nameValidationRegex, phoneValidationRegex } from './regex';

export const firstNameYupValidator = (t: TFunction<string[]>): BaseSchema => {
  return Yup.string()
    .trim()
    .min(
      1,
      t('FormValidations.FieldTooShort', { field: t('Form.FirstName').toLowerCase().toString(), length: 1 }).toString()
    )
    .max(
      30,
      t('FormValidations.FieldTooLong', { field: t('Form.FirstName').toLowerCase().toString(), length: 30 }).toString()
    )
    .matches(
      nameValidationRegex,
      t('FormValidations.InvalidName', { field: t('Form.FirstName').toLowerCase().toString() }).toString()
    )
    .required(`${t('FormValidations.PleaseEnter')} ${t('Prepositions.Your')} ${t('Form.FirstName').toLowerCase()}`);
};

export const lastNameYupValidator = (t: TFunction<string[]>): BaseSchema => {
  return Yup.string()
    .trim()
    .min(
      1,
      t('FormValidations.FieldTooShort', { field: t('Form.LastName').toLowerCase().toString(), length: 1 }).toString()
    )
    .max(
      30,
      t('FormValidations.FieldTooLong', { field: t('Form.LastName').toLowerCase().toString(), length: 30 }).toString()
    )
    .matches(
      nameValidationRegex,
      t('FormValidations.InvalidName', { field: t('Form.LastName').toLowerCase().toString() }).toString()
    )
    .required(`${t('FormValidations.PleaseEnter')} ${t('Prepositions.Your')} ${t('Form.LastName').toLowerCase()}`);
};

export const homePhoneYupValidator = (t: TFunction<string[]>, i18n: I18n): BaseSchema => {
  return Yup.string()
    .matches(
      phoneValidationRegex,
      t('FormValidations.InvalidField', {
        field: (i18n.resolvedLanguage == 'en'
          ? t('Form.PhoneNumber').toLocaleLowerCase()
          : t('Form.PhoneNumber')
        ).toString(),
      }).toString()
    )
    .when('MobileNumber', {
      is: (mobileNumber: string) => !mobileNumber || mobileNumber.length === 0,
      then: Yup.string().required(t('FormValidations.RequiredOnePhone').toString()),
    });
};

export const mobilePhoneYupValidator = (t: TFunction<string[]>, i18n: I18n): BaseSchema => {
  return Yup.string()
    .matches(
      phoneValidationRegex,
      t('FormValidations.InvalidField', {
        field: (i18n.resolvedLanguage == 'en'
          ? t('Form.MobileNumber').toLocaleLowerCase()
          : t('Form.MobileNumber')
        ).toString(),
      }).toString()
    )
    .when('HomeNumber', {
      is: (homeNumber: string) => !homeNumber || homeNumber.length === 0,
      then: Yup.string().required(t('FormValidations.RequiredOnePhone').toString()),
    });
};

export const emailYupValidator = (t: TFunction<string[]>, i18n: I18n): BaseSchema => {
  return Yup.string()
    .email(
      t('FormValidations.InvalidField', {
        field: (i18n.resolvedLanguage == 'en' ? t('Form.Email').toLocaleLowerCase() : t('Form.Email')).toString(),
      }).toString()
    )
    .required(`${t('FormValidations.PleaseEnter')} ${t('Prepositions.A')} ${t('FormValidations.ValidEmail')} `);
};
